import React from 'react';

const EditModal = ({
  selectedDocument,
  editContent,
  setEditContent,
  applySimpleFormat,
  convertToFullHTMLPreview,
  isLoading,
  onSave,
  onClose
}) => {
  return (
    <div className="devis-modal-container">
      <div className="devis-modal-content devis-fade-in">
        {/* En-tête */}
        <div className="devis-modal-header">
          <div>
            <h2 className="devis-modal-title">Modifier le document</h2>
            <p className="devis-modal-subtitle">Édition visuelle avec prévisualisation en temps réel</p>
          </div>
          <button onClick={onClose} className="devis-modal-close">
            ×
          </button>
        </div>

        <div className="devis-modal-body">
          {/* Section outils de formatage */}
          <div className="devis-section">
            <h3 className="devis-section-title">1. Outils de formatage</h3>
            <div className="devis-grid devis-grid-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Formatage de texte</label>
                <div className="flex space-x-2">
                  <button 
                    type="button" 
                    onClick={() => applySimpleFormat('bold')} 
                    className="devis-btn devis-btn-secondary flex-1"
                    title="Gras"
                  >
                    <strong>B</strong>
                  </button>
                  <button 
                    type="button" 
                    onClick={() => applySimpleFormat('italic')} 
                    className="devis-btn devis-btn-secondary flex-1"
                    title="Italique"
                  >
                    <em>I</em>
                  </button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Titres</label>
                <div className="flex space-x-2">
                  <button 
                    type="button" 
                    onClick={() => applySimpleFormat('h2')} 
                    className="devis-btn devis-btn-secondary flex-1"
                    title="Titre principal"
                  >
                    H2
                  </button>
                  <button 
                    type="button" 
                    onClick={() => applySimpleFormat('h3')} 
                    className="devis-btn devis-btn-secondary flex-1"
                    title="Sous-titre"
                  >
                    H3
                  </button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Listes</label>
                <div className="flex space-x-2">
                  <button 
                    type="button" 
                    onClick={() => applySimpleFormat('ul')} 
                    className="devis-btn devis-btn-secondary flex-1"
                    title="Liste à puces"
                  >
                    • Liste
                  </button>
                  <button 
                    type="button" 
                    onClick={() => applySimpleFormat('ol')} 
                    className="devis-btn devis-btn-secondary flex-1"
                    title="Liste numérotée"
                  >
                    1. Liste
                  </button>
                </div>
              </div>
            </div>
            
            <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="text-sm text-blue-800">
                <strong>Astuce :</strong> Sélectionnez du texte puis cliquez sur les boutons, ou utilisez directement les marqueurs :
                <code className="ml-2 px-2 py-1 bg-blue-100 rounded text-blue-700">**gras**</code>
                <code className="ml-1 px-2 py-1 bg-blue-100 rounded text-blue-700">*italique*</code>
                <code className="ml-1 px-2 py-1 bg-blue-100 rounded text-blue-700">## Titre</code>
                <code className="ml-1 px-2 py-1 bg-blue-100 rounded text-blue-700">- liste</code>
              </div>
            </div>
          </div>

          {/* Section édition et prévisualisation */}
          <div className="devis-section">
            <h3 className="devis-section-title">2. Édition et prévisualisation</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Zone d'édition HTML */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Édition du contenu HTML
                  <span className="ml-2 text-xs text-blue-600 font-normal">✓ Édition directe avec prévisualisation</span>
                </label>
                <textarea
                  value={editContent}
                  onChange={(e) => setEditContent(e.target.value)}
                  rows={15}
                  className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
                  placeholder={`Exemples de structure HTML :

<div class="card">
  <h2>Titre de section</h2>
  <p>Contenu de la section...</p>
</div>

<div class="callout">
  <strong>Information importante</strong>
  <p>Texte d'information...</p>
</div>

<ul>
  <li>Élément de liste 1</li>
  <li>Élément de liste 2</li>
</ul>

<table class="table">
  <thead>
    <tr><th>Colonne 1</th><th>Colonne 2</th></tr>
  </thead>
  <tbody>
    <tr><td>Donnée 1</td><td>Donnée 2</td></tr>
  </tbody>
</table>`}
                  style={{
                    fontFamily: 'monospace',
                    fontSize: '14px',
                    lineHeight: '1.4'
                  }}
                />
              </div>

              {/* Prévisualisation complète */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Prévisualisation en temps réel
                  <span className="ml-2 text-xs text-green-600 font-normal">✓ Rendu final exact</span>
                </label>
                <div 
                  className="w-full border border-gray-300 rounded-lg bg-white overflow-hidden"
                  style={{
                    maxHeight: '400px'
                  }}
                >
                  <iframe
                    srcDoc={convertToFullHTMLPreview(editContent, selectedDocument)}
                    title="Prévisualisation du document"
                    className="w-full h-full"
                    style={{
                      height: '400px',
                      border: 'none'
                    }}
                    sandbox="allow-same-origin allow-scripts"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="devis-actions">
            <button
              onClick={onClose}
              className="devis-btn devis-btn-secondary"
              disabled={isLoading}
            >
              Annuler
            </button>
            <button
              onClick={async () => {
                const success = await onSave(selectedDocument, editContent);
                if (success) {
                  onClose();
                }
              }}
              disabled={isLoading || !editContent.trim()}
              className="devis-btn devis-btn-primary"
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Sauvegarde...
                </>
              ) : (
                <>
                  💾 Sauvegarder
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditModal;
